import React, { useState, useEffect } from 'react';
import { Menu, X, ChevronDown } from 'lucide-react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { navigationServices } from '../data/landingPages';
import '../styles/Header.css';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu on route change
  useEffect(() => {
    setMobileMenuOpen(false);
    setServicesOpen(false);
  }, [location.pathname]);

  const goToSection = (id) => {
    if (isHome) {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate(`/#${id}`);
    }
    setMobileMenuOpen(false);
  };

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <div className="logo">
          <Link to="/" className="logo-text" data-testid="header-logo">Sanjib Roy</Link>
        </div>

        <nav className={`nav-menu ${mobileMenuOpen ? 'open' : ''}`}>
          <button onClick={() => goToSection('hero')} className="nav-link" data-testid="nav-home">Home</button>
          <button onClick={() => goToSection('about')} className="nav-link" data-testid="nav-about">About</button>

          {/* Services dropdown: CSS-hover on desktop, click toggle on mobile */}
          <div className={`nav-services ${servicesOpen ? 'is-open' : ''}`}>
            <button
              className="nav-link nav-services-trigger"
              onClick={() => setServicesOpen((v) => !v)}
              aria-expanded={servicesOpen}
              aria-haspopup="true"
              data-testid="nav-services-trigger"
            >
              Services <ChevronDown size={16} strokeWidth={2.5} />
            </button>
            <div className="nav-services-dropdown" data-testid="nav-services-dropdown">
              {navigationServices.map((s) => (
                <Link
                  key={s.slug}
                  to={`/${s.slug}/`}
                  className="nav-services-item"
                  data-testid={`nav-service-${s.slug}`}
                  onClick={() => { setServicesOpen(false); setMobileMenuOpen(false); }}
                >
                  {s.label}
                </Link>
              ))}
            </div>
          </div>

          <button onClick={() => goToSection('skills')} className="nav-link" data-testid="nav-expertise">Expertise</button>
          <button onClick={() => goToSection('experience')} className="nav-link" data-testid="nav-experience">Experience</button>
          <Link to="/blog/" className="nav-link" data-testid="nav-blog" onClick={() => setMobileMenuOpen(false)}>Blog</Link>
          <button onClick={() => goToSection('contact')} className="nav-link nav-cta" data-testid="nav-contact">Contact</button>
        </nav>

        <button
          className="mobile-menu-btn"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
    </header>
  );
};

export default Header;
